// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__u6Y2e","paragraph":"styles_paragraph__7EEi4","loadingAnimation":"styles_loadingAnimation__0OCns","title":"styles_title__5VLuX"};